import React, { Component, Fragment } from 'react'
import { connect } from 'redaction'
import { compose, constants, filterNav, links, mixpanel } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import injectGlobals from 'decorators/injectGlobals'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import HeaderHeight from 'layouts/InsideLayout/Header/HeaderHeight/HeaderHeight'
import HeaderCartButton from 'layouts/InsideLayout/Header/HeaderCartButton/HeaderCartButton'
import HeaderNav from 'layouts/InsideLayout/Header/HeaderNav/HeaderNav'
import HeaderNavItem from 'layouts/InsideLayout/Header/HeaderNavItem/HeaderNavItem'
import HeaderNavItemTitle from 'layouts/InsideLayout/Header/HeaderNavItemTitle/HeaderNavItemTitle'
import HeaderContent from 'layouts/InsideLayout/Header/HeaderContent/HeaderContent'
import HeaderSubNav from 'layouts/InsideLayout/Header/HeaderSubNav/HeaderSubNav'
import HeaderBanner from 'layouts/InsideLayout/Header/HeaderBanner/HeaderBanner'
import Logo from 'components/ui/Logo/Logo'

import UserNavItem from './UserNavItem/UserNavItem'

import messages from './messages'
import s from './HasAuth.scss'


class HeaderHasAuth extends Component {

  static defaultProps = {
    withSubHeader: false,
  }

  trackShareLinkClick = () => {
    mixpanel.track(constants.analyticsEvents.shareLinkClick, {
      placement: 'header link',
    })
  }

  trackFaqLinkClick = () => {
    mixpanel.track(constants.analyticsEvents.faqLinkClick, {
      placement: 'header',
    })
  }

  render() {
    const { withSubHeader, linkToMainPage, isIncubatorNeonHeatEnabled, isFatherDayBambooGiftSetEnabled, intl } = this.props

    const ariaLabel = intl.formatMessage(messages.mainMenu)

    let nav = [
      isIncubatorNeonHeatEnabled ? (
        {
          title: messages.rateNeonHeatKit,
          to: links.incubator.neonHeat,
          withLightningIcon: true,
          dataTestId: constants.testIds.headerNavDrop.rateNeonHeatKit,
        }
      ) : (
        {
          title: messages.getFreeScent,
          to: links.invite,
          onClick: this.trackShareLinkClick,
          dataTestId: constants.testIds.headerNavDrop.getFreeScent,
        }
      ),
      {
        id: 'giftSubMenu', title: messages.sendGift, dataTestId: constants.testIds.headerNavDrop.sendGift, subNav: [
          ...(
            isFatherDayBambooGiftSetEnabled ? [
              { title: messages.fathersDay, to: links.fathersDayGiftSet, dataTestId: 'fatherDay' },
            ] : []
          ),
          { title: messages.gifts, to: links.gifts, dataTestId: constants.testIds.headerNavDrop.gifts },
          { title: messages.giftCard, to: links.giftCard, dataTestId: constants.testIds.headerNavDrop.giftCard },
          { title: messages.giftSetsMen, to: links.giftSetsMen, dataTestId: constants.testIds.headerNavDrop.giftSetsMen },
          { title: messages.giftSetsWomen, to: links.giftSet, dataTestId: constants.testIds.headerNavDrop.giftSetsWomen },
          { title: messages.skincareSets, to: links.skincareSets, dataTestId: constants.testIds.headerNavDrop.skincareSets },
          { title: messages.giftSubscription, to: links.gift, dataTestId: constants.testIds.headerNavDrop.giftSubscription },
        ],
      },
    ]

    nav = filterNav(nav)

    return (
      <Fragment>
        <header className={s.header}>
          <WidthContainer
            tag="ul"
            role="menubar"
            className={s.content}
            ariaLabel={ariaLabel}
          >
            {
              !withSubHeader && (
                <HeaderHeight>
                  <HeaderNavItem className={s.logoNavItem}>
                    <Logo className={s.logo} light to={links.subscription.smartSearch} />
                  </HeaderNavItem>
                </HeaderHeight>
              )
            }
            <li className={s.navigation} role="none">
              <HeaderNav items={nav} />
            </li>
            {
              <HeaderNavItem>
                <HeaderNavItemTitle
                  title={messages.tracking}
                  to={links.tracking}
                  dataTestId={constants.testIds.headerNav.tracking}
                />
              </HeaderNavItem>
            }
            <HeaderNavItem>
              <HeaderNavItemTitle
                title={messages.help}
                redirect={links.faq}
                onClick={this.trackFaqLinkClick}
                dataTestId={constants.testIds.headerNav.help}
              />
            </HeaderNavItem>
            <UserNavItem />
            <HeaderNavItem>
              <HeaderCartButton role="menuitem" />
            </HeaderNavItem>
          </WidthContainer>
        </header>
        {
          withSubHeader && (
            <div>
              <HeaderContent logoLink={linkToMainPage} />
              <HeaderSubNav />
            </div>
          )
        }
        <HeaderBanner />
      </Fragment>
    )
  }
}


export default compose(
  injectIntl,
  injectGlobals(({ getFeatureToggle }) => ({
    isIncubatorNeonHeatEnabled: getFeatureToggle(constants.features.incubatorNeonHeat),
    isFatherDayBambooGiftSetEnabled: getFeatureToggle(constants.features.fatherDayBambooGiftSet),
  })),
  connect({
    linkToMainPage: (state) => {
      const { models: { me: { gender } } } = state

      return gender === 'female' ? links.subscription.mainWomen : links.subscription.mainMen
    },
  }),
)(HeaderHasAuth)
